import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { NgxAimStationSelectDuration } from './ngx-aim-stations-select-duration.class';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'ngx-aim-station-select-duration',
  standalone: true,
  imports: [ButtonModule, RouterLink, FormsModule],
  templateUrl: './ngx-aim-station-select-duration.component.html',
  styleUrl: './ngx-aim-station-select-duration.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxAimStationSelectDurationComponent extends NgxAimStationSelectDuration {}
